import React from 'react'

import { CartIcon } from '@toasttab/buffet-pui-icons'

import { Channel } from 'src/public/js/siteUtilities'

import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext'

import { CartItems } from 'public/components/default_template/online_ordering/cart/Cart'
import { INVALID_CONTENT_CODE } from 'public/components/default_template/online_ordering/cart/constants'
import {
  getCartQuantity,
  ItemSource
} from 'public/components/default_template/online_ordering/cart/cartUtils'
import { useValidateCartForShipping } from 'public/components/default_template/online_ordering/cart/useValidateCartForShipping'

import { useCart } from 'public/components/online_ordering/CartContext'

import CheckoutSection from './CheckoutSection'

import { t } from 'src/translations'

const OrderSection = () => {
  const { cart, channel } = useCart()
  const { orderPath, ecommPath } = useRestaurantRoutes()
  const numItems = getCartQuantity(cart)

  const { validationProblems } = useValidateCartForShipping()

  const hasInvalidContentInCart = validationProblems.some(
    (p) => p.code === INVALID_CONTENT_CODE
  )

  return (
    <CheckoutSection
      title={t('order-section.order-details', { numItems })}
      collapsible
      defaultExpanded={hasInvalidContentInCart}
      icon={<CartIcon />}
    >
      <div className='cartOrder expandableSection'>
        <CartItems
          editable
          validationProblems={validationProblems}
          itemSource={ItemSource.Checkout}
        />
        <a
          href={channel === Channel.ECOMM ? ecommPath : orderPath}
          className='addItemButton'
        >
          {t('cart.add-item')}
        </a>
      </div>
    </CheckoutSection>
  )
}
export default OrderSection
